namespace Indexes {
    export class Printer
    implements StaticIndexDefinition {

        name = "PrinterAll";
        maps = [
            "from u in docs.Printers select new { u.name, u.location }"
        ];
    }
}